import { lazy } from 'react';

import { type SpendingEntityPanelProps } from '../hooks/useSpendingClick';

// Break circular dependency with lazy loading
const PayablePanelContainer = lazy(async () => {
  const module = await import(
    'src/core/modules/bookkeep/payables/containers/PayablePanelContainer'
  );
  return { default: module.PayablePanelContainer };
});

/**
 * Wrap the payable panel to handle more type of entities later and
 * avoid circular dependency between budgets and payables modules
 */
export const SpendingEntityPanel = ({
  payableId,
  onClose,
}: SpendingEntityPanelProps) =>
  payableId ? (
    <PayablePanelContainer payableId={payableId} onClose={onClose} />
  ) : null;
